// import * as API from "./api";
import { createAction, handleActions, combineActions } from 'redux-actions';

const defaultState = {
  accounts: null,
  action_url: null,
  error: null,
  is_connect: null,
  is_fetching: false,
};

export enum PAYPAL_CONNECT_ACTION_TYPES {
  // get merchant id
  GET_MERCHANT_ID_REQUEST = '@DONACO/PAYPAL_GET_MERCHANT_ID_REQUEST',
  // get seller status
  GET_SELLER_STATUS_REQUEST = '@DONACO/PAYPAL_GET_SELLER_STATUS_REQUEST',
  GET_SELLER_STATUS_SUCCEED = '@DONACO/PAYPAL_GET_SELLER_STATUS_SUCCEED',

  FETCH_ALL_ACCOUNTS_REQUEST = '@DONACO/PAYPAL_FETCH_ALL_ACCOUNTS_REQUEST',
  FETCH_ALL_ACCOUNTS_SUCCEED = '@DONACO/PAYPAL_FETCH_ALL_ACCOUNTS_SUCCEED',
  ACCOUNT_IS_CONNECTED = '@DONACO/PAYPAL_ACCOUNT_IS_CONNECTED',

  CONNECT_FAILED = '@DONACO/PAYPAL_CONNECT_FAILED',
  FETCH_ALL_PAYMENTS = '@DONACO/PAYPAL_FETCH_ALL_PAYMENTS',
  FETCH_ALL_PAYMENTS_SUCCEEDED = '@DONACO/PAYPAL_FETCH_ALL_PAYMENTS_SUCCEEDED',

  DISCONNECT_PAYPAL_ACCOUNT_REQUEST = '@DONACO/PAYPAL_DISCONNECT_PAYPAL_ACCOUNT_REQUEST',
  DISCONNECT_PAYPAL_ACCOUNT_SUCCEED = '@DONACO/PAYPAL_DISCONNECT_PAYPAL_ACCOUNT_SUCCEED',

  GET_ORDER_DETAILS_REQUEST = '@DONACO/PAYPAL_GET_ORDER_DETAILS_REQUEST',
  GET_ORDER_DETAILS_SUCCEED = '@DONACO/PAYPAL_GET_ORDER_DETAILS_SUCCEED',

  GET_CAPTURE_DETAILS_REQUEST = '@DONACO/PAYPAL_GET_CAPTURE_DETAILS_REQUEST',
  GET_CAPTURE_DETAILS_SUCCEED = '@DONACO/PAYPAL_GET_CAPTURE_DETAILS_SUCCEED',
}

// Fetch All payment from firebase
export const paypalFetchAllPayments = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.FETCH_ALL_PAYMENTS
);

export const paypalFetchAllPaymentsSucceeded = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.FETCH_ALL_PAYMENTS_SUCCEEDED,
  (payload: string) => payload
);

export const paypalAccountConnectedAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.ACCOUNT_IS_CONNECTED,
  (payload: any) => payload
);

export const getMerchantIdAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_MERCHANT_ID_REQUEST,
  (payload: any) => payload
);

export const getSellerStatusAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_SELLER_STATUS_REQUEST,
  (payload: any) => payload
);

export const getSellerStatusSucceedAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_SELLER_STATUS_SUCCEED,
  (payload: any) => payload
);

export const fetchAllPaypalConnectAccountsRequest = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.FETCH_ALL_ACCOUNTS_REQUEST
);
export const fetchAllPaypalConnectAccountsSucceed = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.FETCH_ALL_ACCOUNTS_SUCCEED,
  (payload: any) => payload
);

export const paypalConnectFailAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.CONNECT_FAILED,
 (payload: any) => payload
);

export const disconnectPaypalAccountRequestAction = createAction(PAYPAL_CONNECT_ACTION_TYPES.DISCONNECT_PAYPAL_ACCOUNT_REQUEST);
export const disconnectPaypalAccountSucceedAction = createAction(PAYPAL_CONNECT_ACTION_TYPES.DISCONNECT_PAYPAL_ACCOUNT_SUCCEED);

/* GET Order details actions */
export const getOrderDetailsRequestAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_ORDER_DETAILS_REQUEST,
  (payload: string) => payload
);
export const getOrderDetailsSucceedAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_ORDER_DETAILS_SUCCEED,
  (payload: any) => payload
);

/* GET capture details actions */
export const getCaptureDetailsRequestAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_CAPTURE_DETAILS_REQUEST,
  (payload: string) => payload
);
export const getCaptureDetailsSucceedAction = createAction(
  PAYPAL_CONNECT_ACTION_TYPES.GET_CAPTURE_DETAILS_SUCCEED,
  (payload: any) => payload
);

export const paypalConnectReducer = handleActions(
  {
    [combineActions(
      PAYPAL_CONNECT_ACTION_TYPES.GET_SELLER_STATUS_REQUEST,
      PAYPAL_CONNECT_ACTION_TYPES.DISCONNECT_PAYPAL_ACCOUNT_REQUEST,
      PAYPAL_CONNECT_ACTION_TYPES.GET_ORDER_DETAILS_REQUEST,
      PAYPAL_CONNECT_ACTION_TYPES.GET_CAPTURE_DETAILS_REQUEST,
    )]: (state) => ({
      ...state,
      is_fetching: true
    }),
    [PAYPAL_CONNECT_ACTION_TYPES.FETCH_ALL_ACCOUNTS_SUCCEED]: (
      state,
      { payload }
    ) => ({
      ...state,
      accounts: payload
    }),
    [PAYPAL_CONNECT_ACTION_TYPES.CONNECT_FAILED]: (state, { payload }) => ({
      ...state,
      is_connect: false,
      error: payload,
      is_fetching: false
    }),
    [PAYPAL_CONNECT_ACTION_TYPES.ACCOUNT_IS_CONNECTED]: (
      state,
      { payload }
    ) => ({
      ...state,
      is_connect: payload,
      is_fetching: false
    }),
    [PAYPAL_CONNECT_ACTION_TYPES.FETCH_ALL_PAYMENTS_SUCCEEDED]: (
      state,
      { payload }
    ) => ({
      ...state,
      payments: payload
    }),
    [PAYPAL_CONNECT_ACTION_TYPES.GET_SELLER_STATUS_SUCCEED]: (
      state,
      { payload }
    ) => ({
      ...state,
      is_connect: payload,
      is_fetching: false
    }),
    [PAYPAL_CONNECT_ACTION_TYPES.DISCONNECT_PAYPAL_ACCOUNT_SUCCEED]: (state) => ({
      ...state,
      is_fetching: false,
      is_connect: false,
      // is_disconnect: true
    }),

    [combineActions(
      PAYPAL_CONNECT_ACTION_TYPES.GET_ORDER_DETAILS_SUCCEED,
      PAYPAL_CONNECT_ACTION_TYPES.GET_CAPTURE_DETAILS_SUCCEED,
      // PAYPAL_CONNECT_ACTION_TYPES.FETCHING_SUCCEED
      )]: (state) => ({
      ...state,
      is_fetching: false,
    })
  },
  defaultState
);
